import {ReferenceDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_REFERENCE_BY_ID';

export async function getReferenceById(userData: Record<string, string>, id: number) {
    try {

        const reference = await ReferenceDao.getReferenceById(userData.userToken, id);

        return reference;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
